import React from 'react';
import { Id } from '../types/Id';
import { RibbonListProps } from '../types/StackedRibbonListComponentTypes';

export type RibbonListContextType<TId extends Id, TItem> = Pick<
  RibbonListProps<TId, TItem>,
  | 'actions'
  | 'actionsVerticalAlignment'
  | 'checkboxVerticalAlignment'
  | 'columns'
  | 'dataGetter'
  | 'disclosureVerticalAlignment'
  | 'enableRowHighlight'
  | 'isIdEmphasized'
  | 'isItemLoaded'
  | 'isLoading'
  | 'isSelectionEnabled'
  | 'itemIdGetter'
  | 'selectionTooltipContent'
  | 'verticalAlignment'
  | 'onRowClick'
> & { componentId: string };

export const RibbonListContext = React.createContext({} as RibbonListContextType<Id, unknown>);
